import React from 'react'
import { useTranslation } from 'react-i18next'
import { config } from '../../../config'

import { Block, ItemExternal, Title } from './components'

const Download: React.FunctionComponent = () => {
    const { t, i18n } = useTranslation('landing')

    return (
        <Block>
            <Title>{t('footer.download.download')}</Title>
            <ItemExternal href={config.stores.android[i18n.language]} target={'_blank'}>Android</ItemExternal>
            <ItemExternal href={config.stores.apple[i18n.language]} target={'_blank'}>iOS</ItemExternal>
        </Block>
    )
}

export default Download